import React from 'react';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MegaMenu } from 'components/mega-menu/megaMenu';
import { BreadcrumbTooltip } from 'components/tooltips/BreadcrumbTooltip';
import { useAppDispatch, useAppSelector } from 'ducks/hooks';
import { clearJobDefinition } from 'ducks/job-definition/slices';
import { setModal } from 'ducks/modals/slices';
import { selectProject } from 'ducks/project/selectors';
import { selectProjects } from 'ducks/projects/selectors';

import cn from 'components/breadcrumbs/Breadcrumbs.module.scss';

export const JobDefinitions = () => {
  const dispatch = useAppDispatch();

  const project = useAppSelector(selectProject);
  const projects = useAppSelector(selectProjects);

  const handleJobDefinitionCreate = () => {
    dispatch(clearJobDefinition());
    dispatch(setModal({ create_job_definition: true }));
  };

  const project_name = `${project.project_name ?? 'Projects'}`;
  return (
    <>
      <div className={cn.items}>
        <MegaMenu labels={project_name} values={projects} page="job_definitions" />
        <FontAwesomeIcon className={cn.breadcrumbIcon} icon={faChevronRight} />
        <div className={cn.breadcrumb}>Job Definitions</div>
        <div className={cn.flexGrow} />
      </div>
      <div className={cn.circle} onClick={handleJobDefinitionCreate}>
        <BreadcrumbTooltip tooltip="Create Job Definition" />
      </div>
    </>
  );
};
